var React = require('react');

function FTArrowChangeMonthLeft (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"11.3,19.7 0.5,10 11.3,0.3 12.7,1.7 3.5,10 12.7,18.3 "}));
}

FTArrowChangeMonthLeft.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 13 20","enableBackground":"new 0 0 13 20","xmlSpace":"preserve"};

module.exports = FTArrowChangeMonthLeft;

FTArrowChangeMonthLeft.default = FTArrowChangeMonthLeft;
